import { useEffect } from "react";
import { useAuthState } from "../context/UserAuthentication/context";
import { handleBrazeUserIdentityChange } from "../helpers/rewardsBrazePlacementCoordinator";

/** Re-fetch banners and reset layout when auth identity changes (login/logout). */
const BrazeBannerIdentitySync = () => {
  const { authInfo } = useAuthState();

  useEffect(() => {
    handleBrazeUserIdentityChange(authInfo?.userId);
  }, [authInfo?.userId]);

  return null;
};

export default BrazeBannerIdentitySync;
